export const accountRegistrationRequiresApproval = (form, submittedValues, submissionResult) => {
    if (typeof submissionResult?.approvalRequired === 'boolean') {
        return submissionResult.approvalRequired;
    }

    const submittedEnableLogin = submittedValues?.customer?.enableLogin;
    if (typeof submittedEnableLogin === 'boolean') return submittedEnableLogin === false;

    return form?.rules?.registerCustomer === true && form?.rules?.enableLogin === false;
};

export const getApprovalReturnUrl = (from, origin) => {
    if (!from?.startsWith('/') || from.startsWith('//')) return '/';

    const resolvedOrigin = origin || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost');

    try {
        const returnUrl = new URL(from, resolvedOrigin);
        if (returnUrl.origin !== new URL(resolvedOrigin).origin) return '/';
        return `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}` || '/';
    } catch {
        return '/';
    }
};

export const getRegistrationSignInHref = from => (
    `/my-account/sign-in${from && from !== '/' ? `?returnUrl=${encodeURIComponent(from)}` : ''}`
);
